import { supabase } from "../client";

// ── Org Settings ─────────────────────────────────────────────

export async function fetchOrgSettings(orgId: string) {
  const { data, error } = await supabase
    .from("org_settings")
    .select("*")
    .eq("org_id", orgId)
    .maybeSingle();
  if (error) throw error;
  return data;
}

export async function updateOrgSettings(orgId: string, fields: Record<string, unknown>) {
  const { error } = await supabase
    .from("org_settings")
    .update({ ...fields, updated_at: new Date().toISOString() })
    .eq("org_id", orgId);
  if (error) throw error;
}

// ── User Brand Access ────────────────────────────────────────

export async function fetchUserBrandAccess(userId: string) {
  const { data, error } = await supabase
    .from("user_brand_access")
    .select("brand_id, role, brands(id, name, slug, org_id, icon_url)")
    .eq("user_id", userId);
  if (error) throw error;
  const rows = data || [];
  // Generate signed URL for brand icon if stored as storage path
  for (const row of rows) {
    const iconUrl = (row as any).brands?.icon_url;
    if (iconUrl && !iconUrl.startsWith("http")) {
      const { data: signed } = await supabase.storage
        .from("brand-assets")
        .createSignedUrl(iconUrl, 60 * 60 * 24);
      if (signed?.signedUrl && (row as any).brands) {
        (row as any).brands.icon_url = signed.signedUrl;
      }
    }
  }
  return rows;
}

// ── User Org Role ────────────────────────────────────────────

export async function fetchUserOrgRole(userId: string) {
  const { data, error } = await supabase
    .from("org_roles")
    .select("org_id, role, organisations(id, name, slug)")
    .eq("user_id", userId)
    .maybeSingle();
  if (error) throw error;
  return data;
}

// ── Organisations ────────────────────────────────────────────

export async function fetchOrganisation(orgId: string) {
  const { data, error } = await supabase
    .from("organisations")
    .select("*")
    .eq("id", orgId)
    .single();
  if (error) throw error;
  return data;
}

// ── Brands ───────────────────────────────────────────────────

export async function fetchBrand(brandId: string) {
  const { data, error } = await supabase
    .from("brands")
    .select("*")
    .eq("id", brandId)
    .single();
  if (error) throw error;
  return data;
}
